module.exports = __webpack_public_path__ + "img/100h100_povorotno_otkidnoe.fb58f3d9.svg";